import { Injectable } from '@angular/core';
import { filter, map, switchMap } from 'rxjs';
import { ApiwrapperService } from 'src/app/services/apiwrapper.service';
import { ModalService } from 'src/app/services/modal.service';
import { ReportStatementComponent } from '../report-statement.component';

@Injectable({
  providedIn: 'root'
})
export class ReportStatementService {

  constructor(
    private api: ApiwrapperService,
    private modalService: ModalService
  ) { }

  openReportStatementModal(reportedStatement: any) {
      return this.api.getReportStatementReasons().pipe(
        map((res: any) => (res._embedded.reasons ?? [])),
        switchMap((res: any) => {
          return this.modalService.openModal(ReportStatementComponent,
            {
              reasons: res,
              reportedStatement: reportedStatement,
              title: {
                key: 'report_statement_modal_title'
              },
              reasonQuestionTitle: {
                key: 'report_statement_modal_reason_question_title'
              },
              warning: {
                key: 'report_statement_modal_note_warning',
              },
              buttons: [
                {labelKey: 'report_statement_modal_cancel_btn', value: false, className: 'no-btn'},
                {labelKey: 'report_statement_modal_submit_btn', value: true, className: 'yes-btn'}
              ]
            },
            { panelClass: ['generic-modal', 'report-statement'],
              width: '88.8rem',
              restoreFocus: false
            }
          ).afterClosed()
        }),
        filter((result: any) => result?.btnValue === true)
      )
    }
}
